// import external dependencies
import 'jquery';
import Masonry from 'masonry-layout';

// Import everything from autoload
import './autoload/_bootstrap.js'

// Swiper
import Swiper, { Autoplay, EffectFade } from 'swiper';

Swiper.use([Autoplay, EffectFade]);

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
	// All pages
	common,
	// Home page
	home,
	// About Us page, note the change from about-us to aboutUs.
	aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

jQuery(document).ready(function($) {
	let header = $('.nf-header');
	let open_menu = $('.nf-header__toggle-menu');
	let menu = $('.nf-header__navigation');
	let overlay = $('.nf-overlay');

	open_menu.click(function() {
		$(this).toggleClass('is-open');
		header.toggleClass('has-menu-open');
		menu.toggleClass('is-open');
		overlay.toggleClass('is-visible');
	});

	overlay.click(function() {
		$(this).toggleClass('is-visible');
		header.toggleClass('has-menu-open');
		menu.toggleClass('is-open');
		open_menu.toggleClass('is-open');
	});

	if($('.swiper-homepage')) {
		new Swiper('.swiper-homepage', {
			lazy: true,
			spaceBetween: 30,
			slidesPerView: 1,
			centeredSlides: true,
			disableOnInteraction: true,
			grabCursor: true,
			direction: 'horizontal',
			autoplay: {
				pauseOnMouseEnter: true,
				delay: 2500,
			},
			loop: true,
			effect: 'fade',
			speed: 2500,
			fadeEffect: {
				crossFade: true,
			},
		});
	}

	if($('.swiper-materia')) {
		new Swiper('.swiper-materia', {
			lazy: true,
			slidesPerView: 2,
			spaceBetween: 20,
			direction: 'horizontal',
			autoWidth: true,
			breakpoints: {
				768: {
					spaceBetween: 30,
				},
				992: {
					slidesPerView: 3,
					spaceBetween: 42,
				},
			},
		});
	}

	if($('.swiper-articles')) {
		new Swiper('.swiper-articles', {
			lazy: true,
			slidesPerView: 2,
			spaceBetween: 20,
			loop: true,
			direction: 'horizontal',
			autoWidth: true,
			breakpoints: {
				768: {
					spaceBetween: 30,
				},
				992: {
					slidesPerView: 'auto',
					spaceBetween: 30,
				},
			},
		});
	}

	if($('.swiper-variants')) {
		new Swiper('.swiper-variants', {
			preloadImages: false,
			// Enable lazy loading
			lazy: true,
			slidesPerView: 2,
			spaceBetween: 20,
			loop: true,
			direction: 'horizontal',
			autoWidth: true,
			breakpoints: {
				768: {
					spaceBetween: 30,
				},
			},
		});
	}

    if($('.swiper-laying-patterns')) {
        new Swiper('.swiper-laying-patterns', {
            lazy: true,
            slidesPerView: 3,
            spaceBetween: 20,
            direction: 'horizontal',
            breakpoints: {
                768: {
                    spaceBetween: 40,
                },
            },
        });
    }

	if($('.nf-article__slides')) {
        new Swiper('.nf-article__slides', {
            lazy: true,
            slidesPerView: 2,
            spaceBetween: 20,
			loop: true,
            direction: 'horizontal',
			autoWidth: true,
            breakpoints: {
                768: {
                    spaceBetween: 40,
                },
            },
        });
    }

	if($('.nf-materia-slides')) {
        new Swiper('.nf-materia-slides', {
            lazy: true,
            slidesPerView: 2,
            spaceBetween: 20,
			loop: true,
            direction: 'horizontal',
            breakpoints: {
                768: {
					slidesPerView: 3.2,
                    spaceBetween: 40,
                },
            },
        });
    }
	
	$('#materiali').submit(function(){
		var filter = $('#materiali');
		var buttonText = $('#materiali button[type="submit"]').text();
		var processingText = $('#materiali input[name="processing"]').val();
		var materiale = $('#materiali select[name="materiale"]').val();
		$.ajax({
			url: filter.attr('action'),
			data: {
				action: 'myfilter',
				materiale: materiale,
			},
			type: filter.attr('method'), // POST
			beforeSend:function(){
				filter.find('button').text(processingText); // changing the button label
				$('.nf-collection-list a').removeClass('show');
				$('.nf-collection-list a').addClass('hide');
			},
			success:function(data){
				filter.find('button').text(buttonText); // changing the button label back
				$('.nf-collection-list .row').html(data); // insert data
				$('.nf-collection-list a').removeClass('hide');
				$('.nf-collection-list a').addClass('show');
			},
		});
		return false;
	});

	if($('.nf-articles-list .row').length) {
		$('.nf-articles-list .row').imagesLoaded(function(){
			new Masonry('.nf-articles-list .row',
				{ itemSelector: '.col-12', percentPosition: true,
			});
		});
	}

	// Filter articles mobile
	$('#filter-categories-select').change(function(){
		var filter = $('#filter-categories-select');
		var categoria = $('#filter-categories-select select[name="nf-filter-categories"]').val();
		var total_number_of_articles = $('.total-number-of-articles').text();
		var posts_ids = []; // Clean array before printing see more button

		$('.nf-articles-list .row .nf-articles-list__article').map(function() {
			posts_ids.push($(this).data('article-id'));
			return posts_ids;
		});

		$.ajax({
			url: filter.attr('action'),
			data: {
				action: 'filter_category',
				categoria: categoria,
			},
			type: filter.attr('method'), // POST
			success:function(data){
				$('.nf-articles-list .row').html(data); // insert data
				$('.nf-articles-list .row').imagesLoaded(function(){
					new Masonry('.nf-articles-list .row',
						{ itemSelector: '.col-12', percentPosition: true,
					});
				});

				var posts_ids = []; // Clean array before printing see more button

				$('.nf-articles-list .row .nf-articles-list__article').map(function() {
					posts_ids.push($(this).data('article-id'));
					return posts_ids;
				});

				if(posts_ids.length <= total_number_of_articles) {
					$('.nf-articles-list__more').fadeOut();
				} else if (posts_ids.length <= total_number_of_articles && $('.nf-articles-list__more').is(':hidden')) {
					$('.nf-articles-list__more').fadeIn();
				} else {
					$('.nf-articles-list__more').fadeIn();
					$('.nf-articles-list__more').text('Vedi altro');
				}
			},
		});
		return false;
	});

	// Filter articles desktop
	$('.nf-filter-categories a').click(function(){
		var categoria = $(this).data('id');
		var total_number_of_articles = $('.total-number-of-articles').text();
		var posts_ids = []; // Clean array before printing see more button

		$('.nf-articles-list .row .nf-articles-list__article').map(function() {
			posts_ids.push($(this).data('article-id'));
			return posts_ids;
		});

		$('.nf-filter-categories a').removeClass('is-active');
		$(this).addClass('is-active');

		$.ajax({
			url: 'https://950.test/wp-admin/admin-ajax.php',
			data: {
				action: 'filter_category',
				categoria: categoria,
			},
			type: 'POST', // POST
			success:function(data){
				$('.nf-articles-list .row').html(data); // insert data
				$('.nf-articles-list .row').imagesLoaded(function(){
					new Masonry('.nf-articles-list .row',
						{ itemSelector: '.col-12', percentPosition: true,
					});
				});

				posts_ids = []; // Clean array before printing see more button

				$('.nf-articles-list .row .nf-articles-list__article').map(function() {
					posts_ids.push($(this).data('article-id'));
					return posts_ids;
				});

				if(posts_ids.length > total_number_of_articles) {
					$('.nf-articles-list__more').fadeOut();
				} else {
					$('.nf-articles-list__more').fadeIn();
					$('.nf-articles-list__more').text('Vedi altro');
				}
			},
		});
		return false;
	});

	// Load more articles
	$('.nf-articles-list__more').click(function() {
		$('.nf-articles-list__more').text('Sto caricando...');

		var posts_ids = [];

		$('.nf-articles-list .row .nf-articles-list__article').map(function() {
			posts_ids.push($(this).data('article-id'));
			return posts_ids;
		});

		var total_number_of_articles = $('.total-number-of-articles').text();
		var categoria = $('.nf-filter-categories a.is-active').data('id');
		$.ajax({
			url: 'https://950.test/wp-admin/admin-ajax.php',
			data: {
				action: 'load_more_posts',
				categoria: categoria,
				posts_ids: posts_ids,
			},
			type: 'POST', // POST
			success:function(data){
				$('.nf-articles-list .row').append(data); // insert data
				$('.nf-articles-list .row').imagesLoaded(function(){
					new Masonry('.nf-articles-list .row',
						{ itemSelector: '.col-12', percentPosition: true,
					});
				});

				posts_ids = []; // Clean array before printing see more button

				$('.nf-articles-list .row .nf-articles-list__article').map(function() {
					posts_ids.push($(this).data('article-id'));
					return posts_ids;
				});

				if(posts_ids.length <= total_number_of_articles) {
					$('.nf-articles-list__more').fadeOut();
				} else if (posts_ids.length > total_number_of_articles && $('.nf-articles-list__more').is(':hidden')) {
					$('.nf-articles-list__more').fadeIn();
				} else {
					$('.nf-articles-list__more').text('Vedi altro');
				}
			},
		});
		return false;
	});

	// Filter types of files mobile
	$('.nf-filter-types-of-files-select').change(function(e){
		e.preventDefault();
		var filter = $('#nf-filter-types-of-files');
		var type_of_file = $('select[name="nf-filter-types-of-files"]').val();
		console.log(type_of_file);

		$.ajax({
			url: filter.attr('action'),
			data: {
				action: 'filter_types_of_files',
				type_of_file: type_of_file,
			},
			type: filter.attr('method'), // POST
			success:function(data){
				$('.nf-files .row').html(data); // insert data
			},
		});
		return false;
	});

	// Filter types of files desktop
	$('.nf-filter-types-of-files a').click(function(){
		var type_of_file = $(this).data('tipologia-id');
		console.log(type_of_file);
		$('.nf-filter-types-of-files a').removeClass('is-active');
		$(this).addClass('is-active');

		$.ajax({
			url: 'https://950.test/wp-admin/admin-ajax.php',
			data: {
				action: 'filter_types_of_files',
				type_of_file: type_of_file,
			},
			type: 'POST', // POST
			success:function(data){
				$('.nf-files .row').html(data); // insert data
			},
		});
		return false;
	});
	
});

$(function(){
	var lastScrollTop = 0, delta = 5;
	$(window).scroll(function(){
		var st = $(this).scrollTop();

	if(Math.abs(lastScrollTop - st) <= delta)
		return;

	if (st > lastScrollTop) {
		// downscroll code
		$('.nf-header').addClass('is-scrolling-down')
		$('.nf-header').removeClass('is-sticky')
	} else {
		// upscroll code
		if($(window).scrollTop() <= 5) {
			$('.nf-header').removeClass('is-scrolling-down');
			$('.nf-header').removeClass('is-sticky');
		} else {
			$('.nf-header').removeClass('is-scrolling-down');
			$('.nf-header').addClass('is-sticky');
		}
	}
	lastScrollTop = st;
	});
});



// WEBPACK FOOTER //
// ./scripts/main.js